import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class TenantMfaSettingsService {
    constructor(api) {
        this.api = api;
    }

    async get() {
        try {
            const response = await withRetry(() => this.api.get(), { maxRetries: 2 });
            return { success: true, data: response.data };
        } catch (error) {
            throw this._handleError(error, 'Failed to load MFA settings');
        }
    }

    async update(data = {}) {
        try {
            const response = await this.api.update(data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to update MFA settings');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
